import axiosClient from "@/libs/axiosClient";

export const getEdgeChartData = (options) => {
    const apiEndpoint = options.apiEndpoint || "/monitor/edgechartdata";
    return axiosClient.post(apiEndpoint, options);
};

export const getEdgeChartDataV2 = (options) => {
    const apiEndpoint = options.apiEndpoint || "/monitor/edgechartdata-v2";
    return axiosClient.post(apiEndpoint, options);
};

export const postBlobPdfBuffer = ({ groupName, data }) => {
    return axiosClient.post(`/monitor/netflowchartdata/upload?groupName=${groupName}`, data);
};

// 準備棄用; 透過上面的api整合
export const getMbChartData = (options) => {
    return axiosClient.post(`/monitor/mbchartdata`, options);
};

export const getSlbExternCheckStats = (hostname) => {
    return axiosClient.get(`/monitor/slbexterncheckstats?hostname=${hostname}`);
};

export const _getAlertRuleLogs = (options) => {
    let { groupName, ruleName, dateTime } = options;
    return axiosClient.get(`/monitor/alertrulelogs?groupName=${groupName}&ruleName=${ruleName}&dateTime=${dateTime}`);
};

export const getDdosAnalyzeChartDataList = ({ groupName, searchTimeRange }) => {
    return axiosClient.get(`/monitor/ddosanalyzechartdata?groupName=${groupName}&searchTimeRange=${searchTimeRange}`);
};

export const getDdosAnalyzeChartData = (id, body, groupName) => {
    return axiosClient.post(`/monitor/ddosanalyzechartdata/${id}?groupName=${groupName}`, body);
};

export const getAvailableQueryKeys = (id) => {
    return axiosClient.get(`/monitor/ddosanalyzechartdata/availableQueryKeys`);
};

export const getAvailableQueryValues = () => {
    return axiosClient.get(`/monitor/ddosanalyzechartdata/availableQueryValues`);
};

export const getBehaviorAnalyzeDataList = ({ groupName, behaviorType, from = 0, size = 10 }) => {
    return axiosClient.get(
        `/monitor/behavioranalyzedata?groupName=${groupName}&behaviorType=${behaviorType}&from=${from}&size=${size}`
    );
};

export const getAccessLogUsage = ({ groupName }) => {
    return axiosClient.get(`/monitor/behavioranalyzedata/usage?groupName=${groupName}`);
};

export const getIpTrafficByCusRealAddr = ({ rid, ip, baseTimestamp, groupName }) => {
    return axiosClient.get(`/monitor/behavioranalyzedata/ip/${ip}/traffic?groupName=${groupName}`, {
        params: {
            rid,
            baseTimestamp,
        },
    });
};

export const getDdosAbnormalTimeline = (id, body, groupName) => {
    return axiosClient.post(`/monitor/ddosanalyzechartdata/${id}/abnormal-timeline/1h?groupName=${groupName}`, body);
};



// WEBPACK FOOTER //
// ./src/api/monitor.js